import React from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '../utils/scroll';
import { StarRating } from './StarRating';
import { motion } from 'framer-motion';
const testimonials = [{
  stars: 5,
  text: 'We went from doing $150k/mo to consistently doing over $250k/mo',
  author: 'Sahil',
  company: 'Founder, JineeGreenCard',
  hasVideo: true,
  videoEmbed: 'https://www.youtube.com/embed/V4KaHkaoi68?si=w5bKtVgYwZFjlLjh',
  quote: 'We went from doing $150k/mo to consistently doing over $250k/mo'
}, {
  stars: 5,
  text: 'We helped Dalal Mehta Law schedule 61 qualified consults from just $2.6k in advertising spend',
  author: 'Dalal Mehta',
  company: 'Attorney, US Immigration Law',
  reviewImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6BQyi1XWgH5KPRqPsCBj2M/25FCC7F2-63A5-434C-BCE8-034DE3AD5357_4_5005_c.jpg',
  quote: 'We helped Dalal Mehta Law schedule 61 qualified consults from just $2.6k in advertising spend.'
}];
export function Testimonials() {
  const location = useLocation();
  const isCasesPage = location.pathname === '/cases';
  const handleApplyClick = () => {
    if (isCasesPage) {
      const element = document.getElementById('application-form');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      window.open('https://calendly.com/customers-on-command/customers-on-command-1-1-interview', '_blank');
    }
  };
  return <section id="case-studies" className="w-full px-6 md:px-12 py-32 bg-white relative z-20" data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-center mb-20" data-id="element-96">
          <h2 className="font-display text-4xl md:text-5xl font-medium mb-4 text-black" data-id="element-97">
            Real Client Results
          </h2>
        </motion.div>
        {/* Mobile Slider */}
        <div className="md:hidden space-y-6" data-id="element-98">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-99">
              <TestimonialCard testimonial={testimonial} data-id="element-100" />
            </motion.div>)}
        </div>
        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-3 gap-8" data-id="element-101">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-102">
              <TestimonialCard testimonial={testimonial} data-id="element-103" />
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-16 flex justify-center" data-id="element-104">
          <button onClick={handleApplyClick} className="bg-primary hover:bg-primary-hover text-black font-medium text-sm py-4 px-10 rounded-full transition-all hover:-translate-y-0.5 active:translate-y-0 w-full md:w-auto text-center cursor-pointer" data-id="element-105">
            APPLY NOW
          </button>
        </motion.div>
      </div>
    </section>;
}
function TestimonialCard({
  testimonial
}: {
  testimonial: (typeof testimonials)[0];
}) {
  return <div className="bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 h-full flex flex-col" data-id="element-106">
      {/* Header */}
      <div className="flex items-center gap-2 mb-6" data-id="element-107">
        <StarRating rating={testimonial.stars} data-id="element-108" />
      </div>
      {/* Content */}
      <div className="flex-grow flex flex-col" data-id="element-109">
        {testimonial.hasVideo && <>
            <div className="relative mb-4 w-full aspect-video rounded-lg overflow-hidden" data-id="element-110">
              <iframe width="100%" height="100%" src={testimonial.videoEmbed} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0" data-id="element-111" />
            </div>
            <p className="font-display text-lg text-navy italic mb-6" data-id="element-112">
              "{testimonial.quote}"
            </p>
          </>}
        {testimonial.reviewImage && <>
            <div className="relative mb-4 w-full rounded-lg overflow-hidden" data-id="element-113">
              <img src={testimonial.reviewImage} alt={`${testimonial.author}'s review`} className="w-full h-auto" data-id="element-114" />
            </div>
            {testimonial.stats && <p className="text-lg text-navy mb-6" data-id="element-115">{testimonial.stats}</p>}
            {testimonial.quote && !testimonial.stats && <p className={`text-lg text-navy mb-6 ${testimonial.quote === 'Actively scheduling qualified meetings for just $77 per call' || testimonial.quote === 'We helped Dalal Mehta Law schedule 61 qualified consults from just $2.6k in advertising spend.' ? '' : 'font-display italic'}`} data-id="element-116">
                {testimonial.quote === 'Actively scheduling qualified meetings for just $77 per call' || testimonial.quote === 'We helped Dalal Mehta Law schedule 61 qualified consults from just $2.6k in advertising spend.' ? testimonial.quote : `"${testimonial.quote}"`}
              </p>}
          </>}
      </div>
      {/* Footer */}
      <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-117">
        <div className="font-bold text-gray-800" data-id="element-118">{testimonial.author}</div>
        <div className="text-muted" data-id="element-119">{testimonial.company}</div>
      </div>
    </div>;
}